export default __webpack_public_path__ + "static/media/Cowboy black.66ef6429.png";